import globalActions from '@/actions'
const state = {
	data: null
}
const mutations = {
	update: (state, data) => {
		state.data = data
		globalActions.setGlobalState({
			identity: state
		});
	}
}
const actions = {
	async get({
		commit
	}) {
		if (state.data == null) {
			const result = await global.gApp.$command.execute({
				api: "/core-merch-api/sys/getIdentity",
				parameter: {}
			})
			//更新identity
			localStorage.setItem("identity", result.data.identity);
			commit('update', result.data)
		}
		return state;
	},
}
export default {
	namespaced: true,
	mutations,
	state,
	actions
}